import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-18e1f434"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "wrapper-contract-info" }
const _hoisted_3 = { class: "info-valor" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Valor a receber:", -1))
const _hoisted_5 = { class: "info" }
const _hoisted_6 = { class: "info-valor" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Forma de pagamento:", -1))
const _hoisted_8 = { class: "info" }
const _hoisted_9 = { class: "info-banco" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Dados bancários para crédito", -1))
const _hoisted_11 = { class: "pw-alert" }
const _hoisted_12 = ["src"]
const _hoisted_13 = { class: "wrapper-checkboxes" }
const _hoisted_14 = { class: "div-btn" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CheckboxInput = _resolveComponent("CheckboxInput")!
  const _component_ButtonDefault = _resolveComponent("ButtonDefault")!
  const _component_SuccessForm = _resolveComponent("SuccessForm")!

  return (_ctx.pageReady)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("p", _hoisted_5, "R$" + _toDisplayString(_ctx.currencyFormatBR(_ctx.credit)), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.installments) + "x mensais", 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("p", null, [
              _createElementVNode("span", null, [
                _createElementVNode("b", null, "Banco: " + _toDisplayString(_ctx.bank), 1)
              ]),
              _createElementVNode("span", null, [
                _createElementVNode("b", null, "Agência: " + _toDisplayString(_ctx.branch), 1)
              ]),
              _createElementVNode("span", null, [
                _createElementVNode("b", null, "Conta: " + _toDisplayString(_ctx.account), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("p", _hoisted_11, _toDisplayString(_ctx.ContractConfiguration.text.pw_exemple), 1),
        _createElementVNode("iframe", { src: _ctx.pdfString }, null, 8, _hoisted_12),
        _createElementVNode("div", _hoisted_13, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ContractConfiguration.text.list, (item, index) => {
            return (_openBlock(), _createBlock(_component_CheckboxInput, {
              key: index,
              modelValue: _ctx.contractData[item.name],
              "onUpdate:modelValue": ($event: any) => ((_ctx.contractData[item.name]) = $event),
              nameID: item.name,
              labelMessage: item.text,
              errors: 
                    !_ctx.checkErrorsReturn(_ctx.messageResponse[_ctx.capitalize(item.name)])
                        ? _ctx.messageResponse[_ctx.capitalize(item.name)]
                        : item.errors
                ,
              isInvalid: 
                    !_ctx.checkErrorsReturn(_ctx.messageResponse[_ctx.capitalize(item.name)])
                        ? true
                        : _ctx.checkboxValidationStatus[item.name] ==
                          _ctx.EValidity.Invalid
                
            }, null, 8, ["modelValue", "onUpdate:modelValue", "nameID", "labelMessage", "errors", "isInvalid"]))
          }), 128)),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_ButtonDefault, {
              id: "btn-submit-request-credit",
              msg: "Assinar",
              onButtonClicked: _ctx.signContract
            }, null, 8, ["onButtonClicked"])
          ]),
          (_ctx.wasContractSigned)
            ? (_openBlock(), _createBlock(_component_SuccessForm, {
                key: 0,
                buttonLabel: "Finalizar",
                messages: ['Contrato assinado'],
                onNewRequestClicked: _ctx.handleSuccessModalClose
              }, null, 8, ["onNewRequestClicked"]))
            : _createCommentVNode("", true)
        ])
      ]))
    : _createCommentVNode("", true)
}